import { URL_TYPES, CHANNEL_TYPES } from '@wix/wix-vod-constants/common';
import { removeUndefinedValues } from '@wix/wix-vod-shared/common';
import getThumbnail from './get-thumbnail';
export function parseYoutubeChannel(urlType, channelData) {
    const { id: externalId, snippet = {}, contentDetails = {}, statistics = {}, brandingSettings = {}, isExternalRemoved = false, } = channelData;
    const { title, description, thumbnails, publishedAt } = snippet;
    const { itemCount, relatedPlaylists = {} } = contentDetails;
    const videosCount = Number(itemCount || statistics.videoCount) || 0;
    const thumbnailUrl = getThumbnail(thumbnails) || null;
    let coverUrl = _.get(brandingSettings, 'image.bannerTvImageUrl') || thumbnailUrl;
    if (urlType === URL_TYPES.PLAYLIST && videosCount === 0) {
        coverUrl = null;
    }
    return removeUndefinedValues({
        externalId,
        uploadsPlaylistId: relatedPlaylists.uploads,
        title,
        description,
        thumbnailUrl,
        coverUrl,
        videosCount,
        externalCreatedTs: new Date(publishedAt),
        channelType: CHANNEL_TYPES.YOUTUBE_FEED,
        urlType,
        isExternalRemoved,
    });
}
//# sourceMappingURL=channel.js.map